import React from 'react';
import { fetchClusterSpinUpsByCategoryData } from 'service/service';
import ClusterDetailsTableBase from './ClusterDetailsTableBase';

const ClusterSpinsUpDetailsTable: React.FC = () => {
    return (
        <ClusterDetailsTableBase
            serviceFunc={fetchClusterSpinUpsByCategoryData}
            pageSubHeaderDefault="Cluster Spin-Ups By Category"
            preserveFilterKey="cluster_spinsup_details_table"
            tableType="cluster-spinsup-details-table"
            backPath="/databricksADB/cluster_spinsup_by_category"
            backBreadcrumbName="Cluster Spin-Ups By Category"
        />
    );
};

export default ClusterSpinsUpDetailsTable;